import Userinputicons from "./user_input_icon.svg";
import dropDwonicons from "./dropdown_icon.svg";
import ClliIcons from "./phone_Number_icon.svg";
import EmailIcons from "./email_icon.svg";
import lockIcons from "./lock_icon.svg";
import lcationIon from "./Location_icon.svg";
import companyName from "./build_icon.svg";
import pricingIcon from "./pricing_icon.svg";
import AccountTypes from "./account_icon.svg";
import hidePasswordIcon from "./hide_password_icon.svg";
import showPasswordIcon from "./show_password_icon.svg";
import cardNumberIcon from "./card_number_icon.svg";
import cardVerificationValue from "./card_verification_value_icon.svg";
import calendarIcon from "./calendar_icon.svg";
import cardHolderNameIcon from "./card_holder_name_icon.svg";
import cardIcon from "./card_icon.svg";
import checkIcon from "./check_icon.svg";
import HomeIcon from "./homeSelected_icon.svg";
import ProfileIcon from "./profile_icon.svg";
import HistoryIcon from "./history_icon.svg";
import StatusIcon from "./status_icon.svg";
import LogoutIcon from "./logout_icon.svg";
import BackBtnIcon from "./BackBtn_Icon.svg";
import ElectronicIcon from "./electronic_icon.svg";
import MaterialIcon from "./material_icon.svg";
import ProjectCostIcon from "./projectCost_icon.svg";
import DocIcon from "./doc_icon.svg";
import BuildingIcon from "./building_icon.svg";
import InfrastructureIcon from "./Infrastructure_icon.svg";
import fileIcon from "./file_icon.svg";
import binIcon from "./bin_icon.svg";
import fileAttechIcon from "./fileAttech_icon.svg";
import ExcelIcon from "./Excel_Icon.svg";
import PDFIcon from "./PDF_icon.svg";
import DwonloadIcon from "./Download_icon.svg";
import HistoryTrackIcon from "./HistoryTrack_icon.svg";
import ProfileblackIcon from "./profileblack_icon.svg";
import ProfileImageEditImg from "./profileImageEdit_icon.svg";
import StatusTrackingIcon from "./StatusTracking_icon.svg";
import HomeBlackIcon from "./home_iconsBlack.svg";
import EnergyIcon from "./Energy_icon.svg";
import EducationIcon from "./education_icon.svg";
import EducationWhiteIcon from "./education_white_icon.svg";
import corporationIcon from "./corporation_icon.svg";
import corporationWhiteIcon from "./corporation_white_icon.svg";
import engineerIcon from "./engineer_icon.svg";
import engineerWhiteIcon from "./engineer_white_icon.svg";
import architectIcon from "./architect_icon.svg";
import architectWhiteIcon from "./architect_white_icon.svg";
import builderIcon from "./builder_icon.svg";
import builderWhiteIcon from "./builder_white_icon.svg";
import talkIcon from "./talk_icon.svg";
import talkWhiteIcon from "./talk_white_icon.svg";
import governmentIcon from "./government_icon.svg";
import governmentWhiteIcon from "./government_white_icon.svg";
import paverIcon from "./paver_icon.svg";
import paverSelectedIcon from "./paver_selected_icon.svg";
import concreteIcon from "./concrete_icon.svg";
import concreteSelectedIcon from "./concrete_selected_icon.svg";
import ReinforcementIcon from "./Reinforcement_icon.svg";
import ReinforcementSelectedIcon from "./Reinforcement_selected_icon.svg";
import GeotechnicalMaterialsIcon from "./Geotechnical_Materials_icon.svg";
import GeotechnicalMaterialsSelectedIcon from "./Geotechnical_Materials_selected_icon.svg";
import waterproofIcon from "./waterproof_icon.svg";
import waterproofSelectedIcon from "./waterproof_selected_icon.svg";
import metalIcon from "./metal_icon.svg";
import metalSelectedIcon from "./metal_selected_icon.svg";
import insulationIcon from "./insulation_icon.svg";
import insulationSelectedIcon from "./insulation_selected_icon.svg";
import shieldIcon from "./shield_icon.svg";
import shieldSelectedIcon from "./shield_selected_icon.svg";
import batteryIcon from "./battery_icon.svg";
import batterySelectedIcon from "./battery_selected_icon.svg";
import watersystemIcon from "./water_system_icon.svg";
import watersystemSelectedIcon from "./water_system_selected_icon.svg";
import directionalIcon from "./directional_sign_icon.svg";
import directionalSelectedIcon from "./directional_sign_selected_icon.svg";
import railwayIcon from "./railway_icon.svg";
import railwaySelectedIcon from "./railway_selected_icon.svg";
import modernBridgeIcon from "./modern_bridge_road_symbol_icon.svg";
import modernBridgeSelectedIcon from "./modern_bridge_road_symbol_selected_icon.svg";
import lengthIcon from "./length_icon.svg";
import lengthSelectedIcon from "./length_selected_icon.svg";
import puffercoatIcon from "./puffer_coat_icon.svg";
import puffercoatSelectedIcon from "./puffer_coat_selected_icon.svg";
import statusCheckIcon from "./status_check_icon.svg";
import categorySelectedIcon from "./selected_Icon.svg";
import arrowIcon from "./arrow_icons.svg";
const Icons = {
  Userinputicons,
  dropDwonicons,
  ClliIcons,
  EmailIcons,
  lockIcons,
  lcationIon,
  companyName,
  pricingIcon,
  AccountTypes,
  hidePasswordIcon,
  showPasswordIcon,
  cardNumberIcon,
  cardVerificationValue,
  calendarIcon,
  cardHolderNameIcon,
  cardIcon,
  checkIcon,
  HomeIcon,
  ProfileIcon,
  HistoryIcon,
  StatusIcon,
  LogoutIcon,
  BackBtnIcon,
  ElectronicIcon,
  MaterialIcon,
  ProjectCostIcon,
  DocIcon,
  BuildingIcon,
  InfrastructureIcon,
  fileIcon,
  binIcon,
  fileAttechIcon,
  ExcelIcon,
  PDFIcon,
  DwonloadIcon,
  HistoryTrackIcon,
  ProfileblackIcon,
  ProfileImageEditImg,
  StatusTrackingIcon,
  HomeBlackIcon,
  EducationIcon,
  EducationWhiteIcon,
  corporationIcon,
  corporationWhiteIcon,
  engineerIcon,
  engineerWhiteIcon,
  architectIcon,
  architectWhiteIcon,
  builderIcon,
  builderWhiteIcon,
  talkIcon,
  talkWhiteIcon,
  governmentIcon,
  governmentWhiteIcon,
  EnergyIcon,
  paverIcon,
  paverSelectedIcon,
  concreteIcon,
  concreteSelectedIcon,
  ReinforcementIcon,
  ReinforcementSelectedIcon,
  GeotechnicalMaterialsIcon,
  GeotechnicalMaterialsSelectedIcon,
  waterproofIcon,
  waterproofSelectedIcon,
  metalIcon,
  metalSelectedIcon,
  insulationIcon,
  insulationSelectedIcon,
  shieldIcon,
  shieldSelectedIcon,
  batteryIcon,
  batterySelectedIcon,
  watersystemIcon,
  watersystemSelectedIcon,
  directionalIcon,
  directionalSelectedIcon,
  railwayIcon,
  railwaySelectedIcon,
  modernBridgeIcon,
  modernBridgeSelectedIcon,
  lengthIcon,
  lengthSelectedIcon,
  puffercoatIcon,
  puffercoatSelectedIcon,
  statusCheckIcon,
  categorySelectedIcon,
  arrowIcon,
};
export default Icons;
